export default __webpack_public_path__ + "static/media/card5.193ceb88.jpg";